import React from 'react';
import PortalLogin from './portal/PortalLogin';
import { TEACHER_PORTAL_ENABLED, getTeacherSession, teacherLogin } from '../../config/teacherApi';

const PortalLaboral: React.FC = () => (
  <PortalLogin
    enabled={TEACHER_PORTAL_ENABLED}
    basePath="/portal-laboral"
    badge="Acceso docentes"
    title="Portal Laboral"
    intro="Consulta tus grupos, tu horario y registra las notas de tus estudiantes desde cualquier lugar."
    hint="Ingresa con el usuario y la contraseña que te envió CECAP."
    userLabel="Usuario"
    userPlaceholder="usuario"
    disabledNotice="El Portal Laboral estará disponible muy pronto."
    hasSession={() => Boolean(getTeacherSession())}
    login={teacherLogin}
  />
);

export default PortalLaboral;
